/**
 * Feedback service — submits user feedback tied to a conversation.
 *
 * Set FEATURES.USE_FEEDBACK_MOCK = false when the backend /feedback endpoint is live.
 */

import { apiClient } from '@/lib/apiClient';
import { FEATURES } from '@/config/appConfig';
import type { FeedbackRequest, FeedbackResponse } from '../types/feedback.types';

const USE_FEEDBACK_MOCK = FEATURES.USE_FEEDBACK_MOCK;

// ---------------------------------------------------------------------------
// Mock
// ---------------------------------------------------------------------------

const mockSubmitFeedback = async (data: FeedbackRequest): Promise<FeedbackResponse> => {
  console.log('[feedbackService] Mock submission:', data);
  await new Promise((resolve) => setTimeout(resolve, 800)); // simulate network delay
  return { status: 'ok', message: 'Feedback received (mock)' };
};

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

export const feedbackService = {
  submitFeedback: async (
    accessToken: string,
    data: FeedbackRequest,
  ): Promise<FeedbackResponse> => {
    if (USE_FEEDBACK_MOCK) return mockSubmitFeedback(data);
    return apiClient<FeedbackResponse>('/feedback', {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
      body: data,
    });
  },
};
